import { useTranslation } from 'react-i18next';

export default function PracticeAreas() {
  const { t } = useTranslation('common');

  const areas = t('practice.areas', { returnObjects: true }) as Array<{
    title: string;
    description: string;
    items: string[];
  }>;

  const differentials = t('practice.differentials.list', { returnObjects: true }) as string[];

  const icons = ['ri-flag-line', 'ri-bank-line', 'ri-store-line'];
  const flags = ['🇺🇸', '🇧🇷', '🌎'];

  return (
    <section id="practice" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <p className="text-sm font-bold text-gray-500 tracking-wider uppercase mb-3">
            {t('practice.badge')}
          </p>
          <h2 className="text-5xl font-serif text-gray-900 mb-6">
            {t('practice.title')} <span className="italic">{t('practice.titleItalic')}</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t('practice.description')}
          </p>
        </div>
        
        <div className="grid grid-cols-3 gap-8">
          {areas.map((area, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-900 to-gray-800 text-white rounded-3xl p-10 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 flex items-center justify-center">
                  <i className={`${icons[index]} text-5xl text-amber-500`}></i>
                </div>
                <span className="text-4xl">{flags[index]}</span>
              </div>
              
              <h3 className="text-2xl font-bold mb-3 leading-tight text-white">
                {area.title}
              </h3>
              
              <p className="text-sm text-gray-400 mb-6 leading-relaxed">
                {area.description}
              </p>
              
              <ul className="space-y-3">
                {area.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-amber-500 text-lg flex-shrink-0 mt-0.5"></i>
                    <span className="text-sm text-gray-300 leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-[#F8F6F3] rounded-3xl p-12">
          <h3 className="text-3xl font-serif text-gray-900 mb-8 text-center">{t('practice.differentials.title')}</h3>
          <div className="grid grid-cols-5 gap-6">
            {differentials.map((differential, index) => {
              const diffIcons = ['ri-global-line', 'ri-lightbulb-line', 'ri-shield-check-line', 'ri-eye-line', 'ri-user-heart-line'];
              return (
                <div key={index} className="text-center">
                  <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4 bg-amber-100 rounded-full">
                    <i className={`${diffIcons[index]} text-2xl text-amber-700`}></i>
                  </div>
                  <p className="text-sm font-semibold text-gray-900">{differential}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
